import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useSetState } from '@campaignhub/react-hooks'

import SidebarModal from '../../../SidebarModal'

import Button from '../../../Button'
import FormField from '../../../FormField'
import Text from '../../../Text'

const defaultState = {
  selectedColumnId: null,
  selectedModuleId: null,
}

const AddDashboardModuleModal = (props) => {
  const {
    availableModules,
    callbacks,
    callbacks: { addModule },
    columns,
    modalKey,
    showModal,
  } = props

  const [state, setState] = useSetState(defaultState)
  const { selectedColumnId, selectedModuleId } = state

  useEffect(() => {
    if (!showModal) setState({ ...defaultState })
  }, [showModal])

  const saveEnabled = selectedColumnId && selectedModuleId

  return (
    <SidebarModal
      callbacks={callbacks}
      modalKey={modalKey}
      showModal={showModal}
      size="small"
    >
      <SidebarModal.Header callbacks={callbacks} title="Add" titleSecondLine="Module" />

      <SidebarModal.Content>
        <Text color="bodyFontLightColor" fontSize="small" lineHeight="1.3" paddingY="large" marginBottom="large">
          Select a column and module from the lists below then click <strong>Add Module to Dashboard</strong> at the
          bottom of the screen
        </Text>

        <FormField direction="column" label="Add to Column">
          {columns.map((column) => {
            const { id, title } = column
            const selected = id === selectedColumnId

            return (
              <Button
                buttonStyle={selected ? 'primaryEdit' : 'secondaryUtility'}
                contentDirection="column"
                key={id}
                onClick={() => setState({ selectedColumnId: id })}
                size="large"
                style={{ marginBottom: 8, paddingTop: 16, paddingBottom: 16 }}
                text={title}
              >
                {title}
              </Button>
            )
          })}
        </FormField>

        {!!selectedColumnId && (
          <FormField direction="column" label="Available Modules" style={{ marginTop: 16 }}>
            {Object.values(availableModules).map((dashboardModule) => {
              const { icon, id, title } = dashboardModule
              const selected = id === selectedModuleId

              return (
                <Button
                  buttonStyle={selected ? 'primaryEdit' : 'secondaryUtility'}
                  flexDirection="column"
                  icon={(
                    <FontAwesomeIcon
                      icon={icon}
                      style={{
                        color: selected ? 'white' : '#8c8c8e',
                        fontSize: 20,
                      }}
                    />
                  )}
                  key={id}
                  onClick={() => setState({ selectedModuleId: id })}
                  size="large"
                  style={{ marginBottom: 8, paddingTop: 16, paddingBottom: 16 }}
                >
                  {title}
                </Button>
              )
            })}
          </FormField>
        )}
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          onClick={() => addModule({ moduleId: selectedModuleId, parentId: selectedColumnId })}
          size="large"
          style={{ width: '100%' }}
        >
          Add Module to Dashboard
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

AddDashboardModuleModal.propTypes = {
  availableModules: PropTypes.object.isRequired,
  callbacks: PropTypes.shape({
    addModule: PropTypes.func.isRequired,
  }).isRequired,
  columns: PropTypes.array.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

AddDashboardModuleModal.defaultProps = {
  modalKey: 'AddDashboardModuleModal',
}

export default AddDashboardModuleModal